import BaseAttribute from '../attributes/baseAttribute';
import DiceAttribute from '../attributes/diceAttribute';
import ValueAttribute from '../attributes/valueAttribute';

export interface CheckResult {
  base: number;
  totalResult: number;
  modifier?: number;
  attributes: BaseAttribute[];
  rolls: number[];
  isCrit: boolean;
  isFail: boolean;
}

export class Checker {
  public static check(attributesToCheck: BaseAttribute[], modifier: number = 0): CheckResult {
    let dices = 0;
    let totalModifier = modifier;
    attributesToCheck.forEach((attribute) => {
      if (attribute instanceof DiceAttribute) {
        dices += attribute.numDice;
        totalModifier += attribute.numBonus;
      } else if (attribute instanceof ValueAttribute) {
        totalModifier += attribute.value;
      }
    });

    let totalResult = totalModifier;
    const rolls: number[] = [];
    for (let i = 0; i < dices; i++) {
      const diceRoll = Math.ceil(Math.random() * 6);
      rolls.push(diceRoll);
      totalResult += diceRoll;
    }

    let isCrit = false;
    let isFail = false;
    if (rolls.filter((roll) => roll === 6).length >= Math.round(dices / 2)) {
      isCrit = true;
    } else if (rolls.filter((roll) => roll === 1).length >= Math.round(dices / 2)) {
      isFail = true;
    }

    if (isCrit) {
      totalResult += 18;
    }

    if (isFail) {
      totalResult -= 18;
    }

    const base = totalModifier;

    const result: CheckResult = { base, totalResult, rolls, isCrit, isFail, attributes: attributesToCheck };

    if (modifier !== 0) {
      result.modifier = modifier;
    }

    return result;
  }
}
